import axios from 'axios'
import { config } from '../Config/config'


const doctorTreatmentService = {
    
    getAll: (filter) => {
        // getAll: () => {
        const result = axios.post(config.apiUrl + '/locationLevelFilter', filter)
            // const result = axios.get(config.apiUrl + '/locationLevel')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getAllData: () => {
        // getAll: () => {
        const result = axios.get(config.apiUrl + '/doctorTreatment')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getAllData2 : (treat) => {
        const result = axios.post(config.apiUrl + '/doctorTreatment2', treat)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },


    addData: (data) => {
        const result = axios.post(config.apiUrl + '/doctorTreatment', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result

    },

    editData: (data) => {
        const result = axios.put(config.apiUrl + '/doctorTreatment', data)
            // const result = axios.post(config.apiUrl+'/categoryById/60249f62c79df0c78d032ab5', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result

    },

    //softDelete
    editDataDelete: (data) => {
        const result = axios.put(config.apiUrl + '/doctorTreatmentDelete', data)
            // const result = axios.post(config.apiUrl+'/categoryById/60249f62c79df0c78d032ab5', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result

    },

    getById: (id) => {
        const result = axios.get(config.apiUrl + '/doctorTreatmentById/' + id)
            //(+ id) => memanggil parameter
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    cekTindakanByName: (data) => {
        const result = axios.get(config.apiUrl + '/cekTindakanByName/'+ data)
        // const result = axios.post(config.apiUrl + '/cekUserByEmail'+ data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    
    cekTindakanByName: (data) => {
        // const result = axios.get(config.apiUrl + '/cekWilayahByName/'+ data)
        const result = axios.post(config.apiUrl + '/cekTindakanByName', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    cekTindakanByDoctorId : (data) => {
        const result = axios.post(config.apiUrl + '/doctorTreatmentByIdDoctor', data)
        // const result = axios.get(config.apiUrl + '/cekDoctorTreatmentByIdDoctorByName/'+ doctor_id+'/'+ data)
        // const result = axios.post(config.apiUrl + '/cekUserByEmail'+ data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    cekTindakanByDoctorIdByName : (data) => {
        const result = axios.post(config.apiUrl + '/cekDoctorTreatmentByIdDoctorByName',data)
        // const result = axios.get(config.apiUrl + '/cekDoctorTreatmentByIdDoctorByName/'+ doctor_id+'/'+ data)
        // const result = axios.post(config.apiUrl + '/cekUserByEmail'+ data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    //masih salah
    cekTindakanByDoctorIdByNameLagi : (data) => {
        const result = axios.get(config.apiUrl + '/Doctor_treatment/'+ data)
        // const result = axios.post(config.apiUrl + '/cekUserByEmail'+ data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },


    // getByCategoryId: (id) => {
    //     const result = axios.get(config.apiUrl + '/customerRelationByCategoryId/' + id)

    //         .then(respon => {
    //             return {
    //                 success: respon.data.success,
    //                 result: respon.data.result
    //             }
    //         })
    //         .catch(error => {
    //             return {
    //                 success: false,
    //                 error: error
    //             }
    //         })
    //     return result
    // },

    // deleteData
    deleteData: (id) => {
        // deleteData: (data) => {
        const result = axios.delete(config.apiUrl + '/doctorTreatment/' + id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    



}

export default doctorTreatmentService
